import React from 'react';
import { MapPin, Phone } from 'lucide-react';
import { locations } from '../data/site';
import { DirectionsChooser } from './DirectionsChooser';

export const MobileActions = () => (
  <nav className="mobile-bottom-bar" aria-label="Quick contact" data-testid="mobile-bottom-bar">
    {locations.map((location) => <a key={location.id} href={location.tel} data-testid={`mobile-call-${location.id}`}>
      <Phone size={18} aria-hidden="true" /><span>{location.id === 'gateway' ? 'Call Gateway' : 'Desert Meadows'}</span>
    </a>)}
    <DirectionsChooser><button type="button" data-testid="mobile-directions-button"><MapPin size={18} aria-hidden="true" /><span>Directions</span></button></DirectionsChooser>
  </nav>
);